import fetch from 'auth/FetchInterceptor'
import store from 'store'

const constantsService = {}

constantsService.getConstants = async function () {
  try {
    const res = await fetch({
      url: '/constants',
      method: 'get',
    })

    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

constantsService.getConstantsUpdated = function (value) {
  const data =
    store.getState().auth?.constants ?? store.getState().constants?.data
  return data ? data[value] : undefined
}

constantsService.getStatus = async function () {
  try {
    const res = await fetch({
      url: '/constants',
      method: 'get'
    });

    // For coverting array
    const statusData = Object.values(res.GENERAL.STATUS).map((val) => val);

    return statusData;
  } catch (err) {
    console.log(err, 'show-err');
  }
};

constantsService.getUserStatus = async function () {
  try {
    const res = await fetch({
      url: '/constants',
      method: 'get'
    });

    // For coverting array
    const statusData = Object.values(res.USER.STATUS).map((val) => val);

    return statusData;
  } catch (err) {
    console.log(err, 'show-err');
  }
};
constantsService.getConstantsRole = async function () {
  try {
    const res = await fetch({
      url: '/constants',
      method: 'get'
    });

    // For coverting array
    const statusData = Object.values(res.USER.SUB_ADMIN_MODULE);
    const keyData = Object.values(res.USER.SUB_ADMIN_KEY)
    let permissionData = []
    for(let i =0; i<statusData.length;i++){
      permissionData.push({
        module: statusData[i],
        key: keyData[i]
      })
    }
    return permissionData;
  } catch (err) {
    console.log(err, 'show-err');
  }
};

constantsService.getSample = async function () {
  try {
    const res = await fetch({
      url: '/sample-files',
      method: 'get',
    })

    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}


export default constantsService
